import React from 'react';
import { cn } from '@/lib/utils';

interface TitleProps extends React.HTMLProps<HTMLHeadingElement> {
  text: string;
}

export default function Title({ text, className = '', ...rest }: TitleProps) {
  return (
    <h1
      className={cn('text-colorText text-2xl md:text-3xl font-semibold', className)}
      {...rest}
    >
      {text}
    </h1>
  );
}
